const separator = '｜';
const timetableCellPrefix = 'timetableCell_';

/**
 * 转换授课周次数据类型，转换为int数组格式[1,2,3]
 * @param weekStr 授课周次
 * @param isUnique 用于判断是否去重
**/
export function convertWeekStrToArray(weekStr, isUnique){
    let finalWeekArray = [];
	let weekArray_1 = weekStr.split(separator);

	for(let i=0; i<weekArray_1.length; i++){
		let weekArray_2 = weekArray_1[i].split('&');

		for(let j=0; j<weekArray_2.length; j++){
			let tempWeek = weekArray_2[j];
            //判断授课周次是连续周次，还是特定周次（如单双周）
            //连续周次格式,如:1-18。
            //特定周次格式,如：1#4#7#9
			if(tempWeek.indexOf('-') > -1){
				let tempStart = parseInt(tempWeek.split('-')[0], 10);
				let tempEnd = parseInt(tempWeek.split('-')[1], 10);

				for(var k=tempStart; k<tempEnd+1; k++){
                    if(isUnique===false || finalWeekArray.indexOf(k)<0){
                        finalWeekArray.push(k);
                    }
				}
			}else{//特别指定的周次
				let tempArray = tempWeek.split('#');

				for(let k=0; k<tempArray.length; k++){
					if(isUnique===false || finalWeekArray.indexOf(parseInt(tempArray[k], 10))<0){
					    finalWeekArray.push(parseInt(tempArray[k]));
					}
				}
			}
		}
	}

	return finalWeekArray.sort((a,b) => { return a - b });
}

/**
 * 转换授课周次数据类型，转换为字符串，例：1-18、1#2#5#7
 * @param weekArray 授课周次
**/
export function convertWeekArrayToStr(weekArray){
    let finalWeekStr = '';

    if(weekArray && weekArray.length>0){
        weekArray.sort((a,b) => { return a - b });

        //判断是否为连续周次
        //连续周次使用 “ - ” 拼接首位
        //非连续使用 “ # ” 拼接单周
        let tempWeekNum = weekArray[0];
        let isContinuous = true;
        for(let i=1; i<weekArray.length; i++){
            tempWeekNum++;

            if(tempWeekNum != weekArray[i]){
                isContinuous = false;
                break;
            }
        }

        if(isContinuous && weekArray.length>1){
            finalWeekStr = weekArray[0] + '-' + weekArray[weekArray.length-1];
        }else{
            finalWeekStr = weekArray.join('#');
        }
    }

	return finalWeekStr;
}

/**
 * 转换授课周次数据格式，转换为字符串，例：1#2#3#4#5
 * @param weekStr 授课周次
**/
export function convertWeekStrWithMark(weekStr, mark){
    let finalWeekStr = '';

    if(weekStr && weekStr.length>0){
        let weekArray_1 = weekStr.split(separator);

        for(let i=0; i<weekArray_1.length; i++){
            let weekArray_2 = weekArray_1[i].split('&');

            for(let j=0; j<weekArray_2.length; j++){
                let tempWeekArray = convertWeekStrToArray(weekArray_2[j], true);
                //排序
                tempWeekArray.sort((a,b) => { return parseInt(a, 10) - parseInt(b, 10) });
                //拼接
                finalWeekStr += tempWeekArray.join(mark) + '&';
            }

            finalWeekStr = finalWeekStr.substring(0, finalWeekStr.length-1);
            finalWeekStr += separator;
        }

        finalWeekStr = finalWeekStr.substring(0, finalWeekStr.length-1);
    }

	return finalWeekStr;
}

/**
 * 解析周次显示方式
 * @param oriWeek 原周次
 * @param oddWeekArray 单周周次数组
 * @param evenWeekArray 双周周次数组
 */
export function formatWeekShow(oriWeek, oddWeekArray, evenWeekArray){
    let result = '';
    let oriWeekArray = oriWeek.split(separator);
    let tempOriWeekArray = new Array();
    let curWeek = '';

    for(let i=0; i<oriWeekArray.length; i++){
        tempOriWeekArray = oriWeekArray[i].split('&');

        if(i > 0){
            result += separator;
        }

        for(let j=0; j<tempOriWeekArray.length; j++){
            curWeek = tempOriWeekArray[j];

            if(j > 0){
                result += '&';
            }

            if(curWeek.indexOf('-') > -1){
                result += curWeek + '周';
            }else if(curWeek == 'odd'){
                result += '单周';
            }else if(curWeek == 'even'){
                result += '双周';
            }else if(curWeek.indexOf('#')>-1 || (curWeek.indexOf('#')<0&&curWeek.length>0&&curWeek.length<3)){
                //判断是否为单双周
                let curWeekArray = curWeek.split('#');
                let oddFlag = true;
                let evenFlag = true;

                if(oddWeekArray.length == curWeekArray.length){
                    for(let i=0; i<oddWeekArray.length; i++){
                        if(oddWeekArray[i] != curWeekArray[i]){
                            oddFlag = false;
                            break;
                        }
                    }
                }else{
                    oddFlag = false;
                }

                if(evenWeekArray.length == curWeekArray.length){
                    for(let i=0; i<evenWeekArray.length; i++){
                        if(evenWeekArray[i] != curWeekArray[i]){
                            evenFlag = false;
                            break;
                        }
                    }
                }else{
                    evenFlag = false;
                }

                if(oddFlag == true)
                    result += '单周';
                else if(evenFlag == true)
                    result += '双周';
                else
                    result += '第' + curWeek.replace(/\#/g, ',') + '周';
            }else{
                result += curWeek;
            }
        }
    }

    return result;
}

/**
 * 格式化时间序列显示
 * @param timeOrder 时间序列
 * @param semesterBaseParams 学期基础参数信息
 */
export function formatTimeOrderShow(timeOrder, semesterBaseParams){
    let timeOrderName = '';

    const weekNum = parseInt(timeOrder.substring(0, 2), 10);
    timeOrderName += semesterBaseParams.weekDayName[weekNum-1];

    const orderNum = parseInt(timeOrder.substring(2), 10);
    let tempOrderName;
    if(orderNum <= semesterBaseParams.forenoonNum){
        tempOrderName = '上午' + orderNum;
    }else if(orderNum <= semesterBaseParams.forenoonNum + semesterBaseParams.noonNum){
        tempOrderName = '中午' + (orderNum - semesterBaseParams.forenoonNum);
    }else if(orderNum <= semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + semesterBaseParams.afternoonNum){
        tempOrderName = '下午' + (orderNum - semesterBaseParams.forenoonNum - semesterBaseParams.noonNum);
    }else if(orderNum <= semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + semesterBaseParams.afternoonNum + semesterBaseParams.eveningNum){
        tempOrderName = '晚上' + (orderNum - semesterBaseParams.forenoonNum - semesterBaseParams.noonNum - semesterBaseParams.afternoonNum);
    }
    timeOrderName += tempOrderName;

    return timeOrderName;
}

/**
 * 通过排课权限获取课表信息中的相应内容
 * @param filterCourseInfo 过滤课程相关信息
 * @param propName 属性名
 * @returns String
 */
export function filterContent(filterCourseInfo, propName){
    let content = filterCourseInfo.courseInfo[propName];

    //判断是否为空白单元格
	if(content === ''){
		return '';
	}
    //判断是否固排课程（管理员允许操作）
    if(filterCourseInfo.courseInfo.arrangeState=='2' && !filterCourseInfo.isAdmin){
        return '';
    }
    //判断是否有全部操作权限
	if(filterCourseInfo.noAuthLimit){
        //判断需要保留的内容类型
		if(filterCourseInfo.keepInfoAuth){
			return content;
		}else{
			return '';
		}
	}

	let resultStr = '';
	let contentArray = content.split(separator);
    let authInfo = filterCourseInfo.userAuthInfo;
	let courseTypeArray = parseCourseType(filterCourseInfo.courseInfo.courseTypeCode.split(separator));
	let courseDeptArray = filterCourseInfo.courseInfo.deptCode.split(separator);

	for(let i=0; i<contentArray.length; i++){
		//判断过滤类型
		if(filterCourseInfo.keepInfoAuth === isAllow(authInfo, courseTypeArray[i], courseDeptArray[i])){
			resultStr = jointContent(resultStr, contentArray[i], separator);
		}
	}

	return resultStr;
}

/**
 * 通过排课权限获取课表信息中的相应内容
 * @param filterCourseInfo 过滤课程相关信息
 * @returns courseInfo
 */
export function filterAllContent(filterCourseInfo){
    let courseInfo = filterCourseInfo.courseInfo;

    //判断是否为空白单元格
    if(courseInfo.planCode === ''){
        return courseInfo;
    }
    //判断是否有全部操作权限
    if(filterCourseInfo.noAuthLimit){
        //判断需要保留的内容类型
        if(filterCourseInfo.keepInfoAuth){
            return courseInfo;
        }else{
             return emptyContent(courseInfo);
        }
    }

    const authInfo = filterCourseInfo.userAuthInfo;
    const courseTypeArray = parseCourseType(courseInfo.courseTypeCode.split(separator));
    const courseDeptArray = courseInfo.deptCode.split(separator);

    const planCodeArray = courseInfo.planCode.split(separator);
    const courseCodeArray = courseInfo.courseCode.split(separator);
    const courseNameArray = courseInfo.courseName.split(separator);
    const courseTypeCodeArray = courseInfo.courseTypeCode.split(separator);
    const deptCodeArray = courseInfo.deptCode.split(separator);
    const teaCodeArray = courseInfo.teaCode.split(separator);
    const teaNameArray = courseInfo.teaName.split(separator);
    const requireSiteCodeArray = courseInfo.requireSiteCode.split(separator);
    const requireSiteNameArray = courseInfo.requireSiteName.split(separator);
    const siteCodeArray = courseInfo.siteCode.split(separator);
    const siteNameArray = courseInfo.siteName.split(separator);
    const weekArray = courseInfo.week.split(separator);
    const weekDetailArray = courseInfo.weekDetail.split(separator);

    let finalPlanCode = '';
    let finalCourseCode = '';
    let finalCourseName = '';
    let finalCourseTypeCode = '';
    let finalDeptCode = '';
    let finalTeaCode = '';
    let finalTeaName = '';
    let finalRequireSiteCode = '';
    let finalRequireSiteName = '';
    let finalSiteCode = '';
    let finalSiteName = '';
    let finalWeek = '';
    let finalWeekDetail = '';

    for(let i=0; i<planCodeArray.length; i++){
    	//判断过滤类型
    	if(filterCourseInfo.keepInfoAuth === isAllow(authInfo, courseTypeArray[i], courseDeptArray[i])){
    		finalPlanCode = jointContent(finalPlanCode, planCodeArray[i], separator);
            finalCourseCode = jointContent(finalCourseCode, courseCodeArray[i], separator);
            finalCourseName = jointContent(finalCourseName, courseNameArray[i], separator);
            finalCourseTypeCode = jointContent(finalCourseTypeCode, courseTypeCodeArray[i], separator);
            finalDeptCode = jointContent(finalDeptCode, deptCodeArray[i], separator);
            finalTeaCode = jointContent(finalTeaCode, teaCodeArray[i], separator);
            finalTeaName = jointContent(finalTeaName, teaNameArray[i], separator);
            finalRequireSiteCode = jointContent(finalRequireSiteCode, requireSiteCodeArray[i], separator);
            finalRequireSiteName = jointContent(finalRequireSiteName, requireSiteNameArray[i], separator);
            finalSiteCode = jointContent(finalSiteCode, siteCodeArray[i], separator);
            finalSiteName = jointContent(finalSiteName, siteNameArray[i], separator);
            finalWeek = jointContent(finalWeek, weekArray[i], separator);
            finalWeekDetail = jointContent(finalWeekDetail, weekDetailArray[i], separator);
    	}
    }

    if(finalPlanCode == '') courseInfo.arrangeState = '';
    courseInfo.planCode = finalPlanCode;
    courseInfo.courseCode = finalCourseCode;
    courseInfo.courseName = finalCourseName;
    courseInfo.courseTypeCode = finalCourseTypeCode;
    courseInfo.deptCode = finalDeptCode;
    courseInfo.teaCode = finalTeaCode;
    courseInfo.teaName = finalTeaName;
    courseInfo.requireSiteCode = finalRequireSiteCode;
    courseInfo.requireSiteName = finalRequireSiteName;
    courseInfo.siteCode = finalSiteCode;
    courseInfo.siteName = finalSiteName;
    courseInfo.week = finalWeek;
    courseInfo.weekDetail = finalWeekDetail;

	return courseInfo;
}

/**
 * 判断是否允许操作
 * @param {Object} authInfo
 * @param {Object} courseType
 * @param {Object} courseDept
 */
function isAllow(authInfo, courseType, courseDept){
    let allowFlag = false;

    for(let j=0; j<authInfo.length; j++){
    	//判断课程类型及开课部门是否允许操作
    	if((courseType==='' || courseType===authInfo[j].courseType)
    		&& (courseDept==='' || authInfo[j].courseDept.indexOf('all')>-1 || authInfo[j].courseDept.indexOf(courseDept)>-1)){
    		allowFlag = true;
    		break;
    	}
    }

    return allowFlag;
}

/**
 * 判断时间序列是否进行过调课操作
 * @param adjustInfo
 * @param timeOrder
 */
/**
export function isAdjust(adjustInfo, timeOrder){
    for(let i=0; i<adjustInfo.length; i++){
        if(adjustInfo[i] === timeOrder){
            return true;
        }
    }

    return false
}
*/
export function isAdjust(adjustInfo, courseInfo){
    //获取课程周次
    const weekArray = convertWeekStrToArray(courseInfo.weekDetail, true);

    for(let i=0; i<adjustInfo.length; i++){
        if(adjustInfo[i].timeOrder === courseInfo.timeOrder){
            const adjustWeekArray = convertWeekStrToArray(adjustInfo[i].weekDetail, true);

            for(let j=0; j<weekArray.length; j++){
                if(adjustWeekArray.indexOf(weekArray[j]) > -1){
                   return true;
                }
            }
        }
    }

    return false
}

/**
 * 清空课程内容
 * @param courseInfo
 */
function emptyContent(courseInfo){
    courseInfo.arrangeState = '';
    courseInfo.planCode = '';
    courseInfo.courseCode = '';
    courseInfo.courseName = '';
    courseInfo.courseTypeCode = '';
    courseInfo.deptCode = '';
    courseInfo.teaCode = '';
    courseInfo.teaName = '';
    courseInfo.requireSiteCode = '';
    courseInfo.requireSiteName = '';
    courseInfo.siteCode = '';
    courseInfo.siteName = '';
    courseInfo.week = '';
    courseInfo.weekDetail = '';

    return courseInfo;
}

/**
 * 解析课程类型
 * @param courseTypeArray
 * @returns array
 */
function parseCourseType(courseTypeArray){
	for(let i=0; i<courseTypeArray.length; i++){
		if(courseTypeArray[i]!='' && courseTypeArray[i]!='01'){
			courseTypeArray[i] = '02';
		}
	}

	return courseTypeArray;
}

/**
 * 拼接课程内容
 * @param content 原内容
 * @param jointStr 拼接内容
 * @param separator 分隔符
 * @returns String
 */
function jointContent(content, jointStr, separator){
	if(content.length > 0){
		content += separator;
	}
	content += jointStr;

	return content;
}

/**
 * 拼接所有字段内容
 * @param info 原信息
 * @param jointInfo 拼接信息
 */
export function jointAllContent(info, jointInfo){
    if(jointInfo.planCode === ''){
        return info;
    }else if(info.planCode === ''){
        return jointInfo;
    }else{
        info.planCode += separator + jointInfo.planCode;
        info.courseCode += separator + jointInfo.courseCode;
        info.courseName += separator + jointInfo.courseName;
        info.courseTypeCode += separator + jointInfo.courseTypeCode;
        info.deptCode += separator + jointInfo.deptCode;
        info.teaCode += separator + jointInfo.teaCode;
        info.teaName += separator + jointInfo.teaName;
        info.requireSiteCode += separator + jointInfo.requireSiteCode;
        info.requireSiteName += separator + jointInfo.requireSiteName;
        info.siteCode += separator + jointInfo.siteCode;
        info.siteName += separator + jointInfo.siteName;
        info.week += separator + jointInfo.week;
        info.weekDetail += separator + jointInfo.weekDetail;

        //信息排序
        sortCourseInfoByWeek(info, separator);

        return info;
    }
}

/**
 * 通过授课周次排序课程信息
 * @param courseInfo 课程信息
 */
function sortCourseInfoByWeek(courseInfo, separator){
    const planCodeArray = courseInfo.planCode.split(separator);
    const courseCodeArray = courseInfo.courseCode.split(separator);
    const courseNameArray = courseInfo.courseName.split(separator);
    const courseTypeCodeArray = courseInfo.courseTypeCode.split(separator);
    const deptCodeArray = courseInfo.deptCode.split(separator);
    const teaCodeArray = courseInfo.teaCode.split(separator);
    const teaNameArray = courseInfo.teaName.split(separator);
    const requireSiteCodeArray = courseInfo.requireSiteCode.split(separator);
    const requireSiteNameArray = courseInfo.requireSiteName.split(separator);
    const siteCodeArray = courseInfo.siteCode.split(separator);
    const siteNameArray = courseInfo.siteName.split(separator);
    const weekArray = courseInfo.week.split(separator);
    const weekDetailArray = courseInfo.weekDetail.split(separator);

    //处理排序信息
    let weekOrderArray = new Array();
    for(let i=0; i<weekArray.length; i++){
        let weekInfo = {
            oriIndex: i,
            weekFirstNum: convertWeekStrToArray(weekArray[i], true)[0]
        };
        weekOrderArray.push(weekInfo);
    }
    weekOrderArray.sort(sortBy('asc', 'weekFirstNum'));

    //清空原数据
    emptyContent(courseInfo);

    //根据排序结果拼接
    let tempSeparator = '';
    for(let i=0; i<weekOrderArray.length; i++){
        const index = weekOrderArray[i].oriIndex;
        courseInfo.planCode += tempSeparator + planCodeArray[index];
        courseInfo.courseCode += tempSeparator + courseCodeArray[index];
        courseInfo.courseName += tempSeparator + courseNameArray[index];
        courseInfo.courseTypeCode += tempSeparator + courseTypeCodeArray[index];
        courseInfo.deptCode += tempSeparator + deptCodeArray[index];
        courseInfo.teaCode += tempSeparator + teaCodeArray[index];
        courseInfo.teaName += tempSeparator + teaNameArray[index];
        courseInfo.requireSiteCode += tempSeparator + requireSiteCodeArray[index];
        courseInfo.requireSiteName += tempSeparator + requireSiteNameArray[index];
        courseInfo.siteCode += tempSeparator + siteCodeArray[index];
        courseInfo.siteName += tempSeparator + siteNameArray[index];
        courseInfo.week += tempSeparator + weekArray[index];
        courseInfo.weekDetail += tempSeparator + weekDetailArray[index];

        tempSeparator = separator;
    }
}

/**
 * 添加验证课程信息
 * @param type 操作类型
 * @param timeOrder 时间序列
 * @param verifyCourseInfo 验证课程信息
 * @param isFilter 是否需要进行过滤处理
 * @param filterCourseInfo 待过滤课程信息
 */
export function addVerifyCourseInfo(type, timeOrder, verifyCourseInfo, isFilter, filterCourseInfo){
    let courseInfo = {
        operationType: type,
        timeOrder: timeOrder,
        planCode: '',
        classCode: '',
        className: '',
        courseName: '',
        teaCode: '',
        teaName: '',
        siteCode: '',
        siteName: '',
        week: '',
    }

    //判断是否需要进行过滤处理
    if(isFilter){
       courseInfo.planCode = filterContent(filterCourseInfo, 'planCode');
       //判断过滤后是否还有课程信息
       if(courseInfo.planCode != ''){
           courseInfo.teaCode = filterContent(filterCourseInfo, 'teaCode');
           courseInfo.siteCode = filterContent(filterCourseInfo, 'siteCode');
           if(type === 'add'){
               courseInfo.classCode = verifyCourseInfo.classCode;
               courseInfo.className = verifyCourseInfo.className;
               courseInfo.courseName = filterContent(filterCourseInfo, 'courseName');
               courseInfo.teaName = filterContent(filterCourseInfo, 'teaName');
               courseInfo.siteName = filterContent(filterCourseInfo, 'siteName');
               courseInfo.week = filterContent(filterCourseInfo, 'week');
           }
           verifyCourseInfo.courseList.push(courseInfo);
       }
    }else{
        courseInfo.planCode = filterCourseInfo.courseInfo.planCode;
        courseInfo.teaCode = filterCourseInfo.courseInfo.teaCode;
        courseInfo.siteCode = filterCourseInfo.courseInfo.siteCode;
        if(type === 'add'){
            courseInfo.classCode = verifyCourseInfo.classCode;
            courseInfo.className = verifyCourseInfo.className;
            courseInfo.courseName = filterCourseInfo.courseInfo.courseName;
            courseInfo.teaName = filterCourseInfo.courseInfo.teaName;
            courseInfo.siteName = filterCourseInfo.courseInfo.siteName;
            courseInfo.week = filterCourseInfo.courseInfo.week;
        }
        verifyCourseInfo.courseList.push(courseInfo);
    }
}

/**
 * 获取当前班级相关教师/场地/场地类型信息
 * @param timetableInfo 课表信息
 * @param teachingPlanInfo 教学计划信息
 */
export function handleUsedRelatedInfo(timetableInfo, teachingPlanInfo){
    let teaCodeArray = [];
    let siteCodeArray = [];
    let siteTypeArray = [];
    let siteDeptArray = [];

	//课表信息
    if(timetableInfo && timetableInfo.length>0){
        for(let i=0; i<timetableInfo.length; i++){
            if(timetableInfo[i].planCode != ''){
                //教师信息
                let tempTeaArray = covertStrToDistinctArray(timetableInfo[i].teaCode);
                for(let j=0; j<tempTeaArray.length; j++){
                    if(teaCodeArray.indexOf(tempTeaArray[j]) < 0){
                        teaCodeArray.push(tempTeaArray[j]);
                    }
                }

                //场地信息
                let tempSiteArray = covertStrToDistinctArray(timetableInfo[i].siteCode);
                for(let j=0; j<tempSiteArray.length; j++){
                    if(siteCodeArray.indexOf(tempSiteArray[j]) < 0){
                        siteCodeArray.push(tempSiteArray[j]);
                    }
                }
            }
        }
    }

	//未排课程信息
    if(teachingPlanInfo && teachingPlanInfo.length>0){
        for(let i=0; i<teachingPlanInfo.length; i++){
            //教师信息
            let tempTeaArray = covertStrToDistinctArray(teachingPlanInfo[i].teaCode);
            for(let j=0; j<tempTeaArray.length; j++){
                if(teaCodeArray.indexOf(tempTeaArray[j]) < 0){
                    teaCodeArray.push(tempTeaArray[j]);
                }
            }

            //场地信息
            let tempSiteArray = covertStrToDistinctArray(teachingPlanInfo[i].siteCode);
            for(let j=0; j<tempSiteArray.length; j++){
                if(tempSiteArray[j].length < 3){
                    if(siteTypeArray.indexOf(tempSiteArray[j]) < 0){
                        siteTypeArray.push(tempSiteArray[j]);
                    }
                }else{
                    if(siteCodeArray.indexOf(tempSiteArray[j]) < 0){
                        siteCodeArray.push(tempSiteArray[j]);
                    }
                }
            }

            //开课部门
            if(siteDeptArray.indexOf(teachingPlanInfo[i].deptCode) < 0){
                siteDeptArray.push(teachingPlanInfo[i].deptCode);
            }
        }
    }

    let info = {
        teaCode: teaCodeArray.toString(),
        siteCode: siteCodeArray.toString(),
        siteType: siteTypeArray.toString(),
        siteDept: siteDeptArray.toString(),
    };

    return info;
}

/**
 * 解析教师/场地使用信息
 * @param classCode 当前班级代码
 * @param usedInfo 原使用信息
 * @param timeOrderInfo 时间序列信息
 * @param otherSourceCode 其他数据源代码
 */
export function parseUsedOrderInfo(classCode, usedOrderInfo, timeOrderInfo, otherSourceCode){
    for(let i=0; i<usedOrderInfo.length; i++){
        let curUsedInfo = usedOrderInfo[i].usedInfo;
        let finalUsedInfoArray = new Array();

        for(let j=0; j<timeOrderInfo.length; j++){
            //获取当前时间序列及具体时间信息
            const curTimeOrder = timeOrderInfo[j].order;
            const curStartTime = parseInt(timeOrderInfo[j].time.replace(/\:/g, '').split('~')[0], 10);
            const curEndTime = parseInt(timeOrderInfo[j].time.replace(/\:/g, '').split('~')[1], 10);

            let finalUsedInfo = {
                timeOrder: curTimeOrder,
                usedInfo: new Array(),
            };

            for(let k=0; k<curUsedInfo.length; k++){
                var usedTimeOrder = curUsedInfo[k].timeOrder;
                var otherStartTime = parseInt(curUsedInfo[k].timeDetail.split('-')[0], 10);
                var otherEndTime = parseInt(curUsedInfo[k].timeDetail.split('-')[1], 10);

                //判断如果时间序列相同，处理已用信息数据
                if(curTimeOrder == usedTimeOrder){
                    let tempUsedInfoArray = parseCourseInfo(classCode, usedOrderInfo[i].code, usedOrderInfo[i].name, curUsedInfo[k], 'current');
                    finalUsedInfo.usedInfo = finalUsedInfo.usedInfo.concat(tempUsedInfoArray);
                }

                //时间交错，查询其他学校内容
                if(curTimeOrder.substring(0, 2)==usedTimeOrder.substring(0, 2) && !(curEndTime<otherStartTime || curStartTime>otherEndTime)){
                    let tempUsedInfoArray = parseCourseInfo(classCode, usedOrderInfo[i].code, usedOrderInfo[i].name, curUsedInfo[k], otherSourceCode);
                    finalUsedInfo.usedInfo = finalUsedInfo.usedInfo.concat(tempUsedInfoArray);
                }
            }

            finalUsedInfoArray.push(finalUsedInfo);
        }

        usedOrderInfo[i].usedInfo = finalUsedInfoArray;
    }

    return usedOrderInfo;
}

/**
 * 解析上课信息
 * @param code 当前教师/场地编号
 * @param name 当前教师/场地名称
 * @param courseInfo //当前上课信息
 * @param sourceCode //数据源编号
 */
function parseCourseInfo(classCode, code, name, courseInfo, sourceCode){
    let resultArray = new Array();
    let planCodeArray = courseInfo.planCode.split(separator);//授课计划编号
    let codeArray = courseInfo.code.split(separator);//授课教师/场地编号
    let courseNameArray = courseInfo.courseName.split(separator);//课程名称
    let classCodeArray = courseInfo.classCode.split(separator);//班级编号
    let classNameArray = courseInfo.className.split(separator);//班级名称
    let weekArray = courseInfo.week.split(separator);//授课周次
    let dataSource = courseInfo.dataSource.split(separator);//数据来源

    for(let j=0; j<codeArray.length; j++){
        //过滤当前班级信息
        if(classCodeArray[j] === classCode) continue;

        //判断是否需要查询的数据（同校/其他学校）
        if(dataSource[j] == sourceCode){
            let tempCodeArray = codeArray[j].split('&');
            let tempWeekArray = weekArray[j].split('&');

            for(let k=0; k<tempCodeArray.length; k++){
                let tempCode = tempCodeArray[k].split('+');

                for(let a=0; a<tempCode.length; a++){
                    //判断编号是否相同
                    if(tempCode[a] == code){
                        let courseInfo = {
                            planCode: planCodeArray[j],//授课计划编号
                            name: name,//教师/场地名称
                            courseName: courseNameArray[j],//课程名称
                            className: classNameArray[j],//班级名称
                            week: convertWeekStrToArray(tempWeekArray[k], true),//授课周次
                        };
                        resultArray.push(courseInfo);
                    }
                }
            }
        }
    }

    return resultArray;
}

/**
 * 解析合班设置信息
 * @param oriMergeClassConfigInfo 原合班设置信息
 */
export function parseMergeClassConfigInfo(oriMergeClassConfigInfo){
    let fianlMergeClassConfigInfo = new Array();

    for(let i=0; i<oriMergeClassConfigInfo.length; i++){
        let configInfo = {
            planCode: oriMergeClassConfigInfo[i].mergePlanCode.split('+'),
            className: oriMergeClassConfigInfo[i].mergeClassName.split('+'),
            totalStuNum: oriMergeClassConfigInfo[i].totalStuNum,
        };
        fianlMergeClassConfigInfo.push(configInfo);
    }

    return fianlMergeClassConfigInfo;
}

/**
 * 解析合班上课信息
 * @param {Object} oriMergeClassCourseInfo 原合班上课信息
 */
export function parseMergeClassCourseInfo(oriMergeClassCourseInfo){
    let finalMergeClassCourseInfo = new Array();

    for(let i=0; i<oriMergeClassCourseInfo.length; i++){
        let courseInfo = {
            timeOrder: oriMergeClassCourseInfo[i].timeOrder,
            planCode: oriMergeClassCourseInfo[i].planCode.split('+'),
            courseName: mergeCourseName(oriMergeClassCourseInfo[i].courseName),
            className: oriMergeClassCourseInfo[i].className,
            siteCode: oriMergeClassCourseInfo[i].siteCode,
            siteName: oriMergeClassCourseInfo[i].siteName,
        };

        finalMergeClassCourseInfo.push(courseInfo);
    }

    return finalMergeClassCourseInfo;
}

/**
 * 合并课程名称
 * @param oriCourseName 原课程名称
 */
function mergeCourseName(oriCourseName){
    let tempCourseNameArray = oriCourseName.split("、");
    let courseNameArray = new Array();
    for(let j=0; j<tempCourseNameArray.length; j++){
        if(courseNameArray.indexOf(tempCourseNameArray[j]) < 0) {
            courseNameArray.push(tempCourseNameArray[j]);
        }
    }

    let finalCourseName = '';
    for(let j=0; j<courseNameArray.length; j++) {
        finalCourseName += courseNameArray[j]+"、";
    }
    finalCourseName = finalCourseName.substring(0, finalCourseName.length-1);

    return finalCourseName;
}

/**
 * 判断待操作的课程内容是否相同
 * @param isIgnoreClassConflict
 * @param planCodeArray_1
 * @param planCodeArray_2
 */
export function isSameCourse(isIgnoreClassConflict, planCodeArray_1, planCodeArray_2){
    if(isIgnoreClassConflict || planCodeArray_1.length===planCodeArray_2.length){
        for(let i=0; i<planCodeArray_1.length; i++){
            let isExist = false;

            for(let j=0; j<planCodeArray_2.length; j++){
                if(planCodeArray_1[i] === planCodeArray_2[j]){
                    isExist = true;
                    break;
                }
            }

            if(isExist === false){
                return false;
            }
        }

        return true;
    }else{
        return false;
    }
}

/**
 * 判断周次是否冲突
 * @param weekArray_1
 * @param weekArray_2
 */
export function isWeekConflict(weekArray_1, weekArray_2){
    for(let i=0; i<weekArray_1.length; i++){
        for(let j=0; j<weekArray_2.length; j++){
            if(weekArray_1[i] == weekArray_2[j]){
                return true;
            }
        }
    }

    return false;
}

/**
 * 将拼接的教师/场地信息转换为数组（去重）
 */
function covertStrToDistinctArray(str){
	let resultArray = new Array();

	let tempArray_1 = str.split(separator);

	for(let i=0; i<tempArray_1.length; i++){
		let tempArray_2 = tempArray_1[i].split('&');

		for(let j=0; j<tempArray_2.length; j++){
			let tempArray_3 = tempArray_2[j].split('+');

			for(let k=0; k<tempArray_3.length; k++){
				if(resultArray.indexOf(tempArray_3[k]) < 0){
					resultArray.push(tempArray_3[k]);
				}
			}
		}
	}

	return resultArray;
}

/**
 * 判断选择单元格的内容是否能够与目标单元格的内容拼接
 * @param selectCell
 * @param targetCell
 */
export function isAllowJointWithAllCourse(selectCell, targetCell){
    const weekArray_1 = convertWeekStrToArray(selectCell.week, true);
    const weekArray_2 = convertWeekStrToArray(targetCell.week, true);
    return !isWeekConflict(weekArray_1, weekArray_2)
}

/**
 * 判断是否可与目标单元格无权操作的课程进行拼接
 * @param filterCourseInfo 课程信息过滤对象
 * @param selectCell 选择单元格
 * @param targetCell 目标单元格
 */
export function isAllowJointWithNoAuthCourse(filterCourseInfo, selectCell, targetCell){
    //选择单元格拼接到目标单元格
    //获取选择单元格无权限操作的内容
    let weekArray_1 = convertWeekStrToArray(selectCell.week, true);
    //获取目标单元格无权限操作的内容
    filterCourseInfo.courseInfo = targetCell;
    filterCourseInfo.keepInfoAuth = false;
    let weekArray_2 = convertWeekStrToArray(filterContent(filterCourseInfo, 'week'), true);
    if(isWeekConflict(weekArray_1, weekArray_2)){
       return false;
    }

    //判断选择单元格如果是课表中的单元格，需检查目标单元格是否可以拼接到选择单元格
    if(selectCell.id.indexOf(timetableCellPrefix) > -1){
        //获取选择单元格无权限操作的内容
        let tempSelCellId = selectCell.id.substring(selectCell.id.indexOf('_')+1);
        filterCourseInfo.courseInfo = targetCell;
        filterCourseInfo.keepInfoAuth = false;
        //获取目标单元格有权限操作的内容
        let weekArray_1 = convertWeekStrToArray(filterContent(filterCourseInfo, 'week'), true);
        filterCourseInfo.courseInfo = targetCell;
        filterCourseInfo.keepInfoAuth = true;
        let weekArray_2 = convertWeekStrToArray(filterContent(filterCourseInfo, 'week'), true);

        if(isWeekConflict(weekArray_1, weekArray_2)){
           return false;
        }
    }

    return true;
}

/**
 * 自定义排序字段
 * @param property
 */
export function sortBy(type, property){
    return (obj_1, obj_2) => {
        if(type === 'asc'){
            return obj_1[property] - obj_2[property];
        }else{
            return obj_2[property] - obj_1[property];
        }
    }
}

/**
 * 设置待过滤课程信息对象
 * @param filterCourseInfo 待过滤课程信息对象
 * @param courseInfo 完整课程信息
 * @param keepInfoAuth 过滤类型（true:保留有权限内容 / false:保留无权限内容）
 */
export function setFilterCourseInfo(filterCourseInfo, courseInfo, keepInfoAuth){
    filterCourseInfo.courseInfo = JSON.parse(JSON.stringify(courseInfo));
    filterCourseInfo.keepInfoAuth = keepInfoAuth;
}

/**
 * 获取id中的下标信息
 * @param id
 */
export function getIndexById(id){
    return parseInt(id.substring(id.indexOf('_')+1), 10);
}



// WEBPACK FOOTER //
// ./src/utils/timetableCommon.js